import { hydrate, mount } from 'svelte';
import { overallScores, group } from '../api';
import {
  TrainingTable,
  Gauge,
} from '../../components';

import { makeConversation } from '../fn';

import type { TrainingState } from '.';

const segment = 'training';

let trainingState: TrainingState = $state({
  tableData: [],
  gauge: 0,
});

const DOM = {
  trainingTable: document.getElementById('training-table'),
  gauge: document.getElementById('uc-gauge'),
}

async function fetchEverythingTraining(groupCode) {
  const [overallScoresResponse] = await Promise.all([
    // fetch(`${group}/${segment}/${groupCode}`),
    fetch(`${overallScores}/${groupCode}`)
  ])

  
  // const groupData = await groupResponse.json();
  const overallRes = await overallScoresResponse.json();

  // This is where we set the next page URL
  // if(!isLastPageTest(groupData.isLastPage)) {
  //   // we'll give the component the URL for page 2, and let the component handle fetching the rest
  //   groupData.moreTrainingTableDataUrl = `${group}/${segment}/${groupCode}?page=2`
  // }

  return [overallRes.data[0]]
}

async function mountComponents(groupCode: string) {
  if(DOM.gauge) {
    hydrate(Gauge, {
      target: DOM.gauge,
      props: {
        dashboardState: trainingState,
        segment,
      }
    })
  }

  if(DOM.trainingTable) {
    hydrate(TrainingTable, {
      target: DOM.trainingTable,
      props: {
        trainingDashboardState: trainingState,
        // tableExportTitle: overallScores.GroupName,
        dataUrl: `${group}/${segment}/${groupCode}`,
        moreDataUrl: `${group}/training/${groupCode}?page=2`,
      }
    })
  }
}




export async function buildTraining(groupCode: string|undefined = 'uc') {
  mountComponents(groupCode);
  makeConversation();

  const [overallScores] = await fetchEverythingTraining(groupCode);
  
  // trainingState.tableData = groupData;
  trainingState.gauge = overallScores.RecentTrainingScore;

  // if(DOM.gauge) {
  //   hydrate(Gauge, {
  //     target: DOM.gauge,
  //     props: {
  //       val: Number(overallScores.RecentTrainingScore).toFixed(1),
  //       segment: 'training',
  //     }
  //   })
  // }

  // if(DOM.trainingTable) {
  //   hydrate(TrainingTable, {
  //     target: DOM.trainingTable,
  //     props: {
  //       tableData: groupData.data,
  //       tableExportTitle: overallScores.GroupName,
  //       moreDataUrl: isLastPageTest(groupData.isLastPage) ? `${group}/training/${groupCode}?page=2` : undefined,
  //     }
  //   })
  // }

  
}